var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "<div class=\"popover bottom show mkts-cmpt-svgcht-popover\">\n    <div class=\"mkts-cmpt-svgcht-popover-arrow arrow\"></div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isShowRelateTickerAndMajorIndex : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <table class=\"mkts-cmpt-svgcht-search-table\">\n    </table>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isShowRelateTickerAndMajorIndex : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/html/menuBar/autocompleteContainer.html
// module id = 35
// module chunks = 0